module.exports = __webpack_public_path__ + "static/media/Gentona Thin.a81edbc3.otf";